import Contact from 'src/components/sidebar/Contact';

import AddressBlock from './AddressBlock';

export default function Sidebar() {
  return (
    <>
      <Contact
        officePhone="801-851-4138"
        nonEmergency="801-798-5600"
        emEmail="em@utahcounty.gov"
        lieutenant="Peter Quittner"
        lieutenantEmail="PeterQ@utahcounty.gov"
      />
      <AddressBlock
        title="MAIN OFFICE"
        subTitle="Utah County Security Center"
        lines={['3075 North Main', 'Spanish Fork, UT 84660', '801-851-4000', '801-851-4009 (Fax)']}
      />
      <AddressBlock
        title="JUDICIAL SUPPORT BUREAU"
        subTitle="Utah County Health and Justice Building"
        lines={[
          '151 South University Ave.',
          'Suite 3110',
          'Provo, UT 84601',
          '801-851-4040',
          '801-851-4039 (Fax)',
          'Hours: 8:00 AM - 5:00 PM',
          'MON - FRI, excluding holidays',
        ]}
      />
      <AddressBlock
        title="UTAH COUNTY JAIL"
        subTitle="Utah County Security Center"
        lines={['3075 North Main', 'Spanish Fork, UT 84660', '801-851-4302', '801-851-4219 (Fax)']}
      />
    </>
  );
}
